export const typographyKeys = [
    "fontFamily",
    "fontStyle",
    "fontSize",
    "fontWeight",
    "fontVariant",
    "lineHeight",
    "letterSpacing",
    "whiteSpace",
    "wordBreak",
    "wordSpacing",
    "textAlign",
    "textDecoration",
    "textAlign",
    "textIndent",
    "textOverflow",
    "textTransform",
];
export const colorKeys = [
    "backgroundColor",
    "borderColor",
    "borderTopColor",
    "borderBottomColor",
    "borderLeftColor",
    "borderRightColor",
    "color",
];
const deconstructObj = (key, value) => {
    if (key === "paddingHorizontal") {
        return {
            paddingLeft: value,
            paddingRight: value,
        };
    }
    if (key === "paddingVertical") {
        return {
            paddingTop: value,
            paddingBottom: value,
        };
    }
    return { [key]: value };
};
export const applyTokens = (tokens, types) => {
    const keys = types || Object.keys(tokens);
    return keys.reduce((acc, key) => {
        if (!(key in tokens)) {
            return acc;
        }
        else {
            const token = tokens[key];
            if (!token || !("value" in token)) {
                return acc;
            }
            return Object.assign(Object.assign({}, acc), deconstructObj(key, token.value));
        }
    }, {});
};
//# sourceMappingURL=applyTokens.js.map